import { Pipe, PipeTransform } from '@angular/core';
import { CustomFieldsV2Service } from 'src/app/company-settings/custom-fields-v2/custom-fields-v2.service';

// common pipe for transforming id to name to activity fields that supports custom values [we are showing and working with names but server contract are Ids]
@Pipe({
  standalone: true,
  name: 'systemFieldIdToName'
})
export class SystemFieldIdToNamePipe implements PipeTransform {

  constructor(
    private customFieldsV2Service: CustomFieldsV2Service,
  ) {}

  transform(id: string): string {
      const trimmed = id?.trim();
      return this.customFieldsV2Service.getOption(trimmed)?.text?.trim() ?? id;
  }

}
